module.exports = __webpack_public_path__ + "img/document-download.bc63a638.svg";